import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const categoryName = categories.find((c) => c.slug === video.category)?.name || video.category;

  return (
    <article className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300" data-product-shop>
      <Link to={`/category/${video.category}`} className="block relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 私密视频`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
            {video.quality}
          </span>
        </div>
        <div className="absolute bottom-3 right-3">
          <span className="px-2 py-1 bg-black/70 text-white text-xs rounded-md whitespace-nowrap">
            {video.duration}
          </span>
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 opacity-0 group-hover:opacity-100 transition-all duration-300 scale-75 group-hover:scale-100">
            <i className="ri-play-fill text-2xl"></i>
          </div>
        </div>
      </Link>
      <div className="p-3 md:p-4">
        <Link to={`/category/${video.category}`} className="block">
          <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200 mb-2">
            {video.title}
          </h3>
        </Link>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views}
          </span>
          <span className="px-2 py-0.5 bg-background-100 rounded-full text-foreground-500 whitespace-nowrap">
            {categoryName}
          </span>
        </div>
      </div>
    </article>
  );
}